export default "__VITE_ASSET__2TBBkE2T__"